import { reactive, toRefs, UnwrapRef } from 'vue'

import { Nullable } from '@shared/models/types/primary'

export const useFetchData = <T>() => {
  const state = reactive<{
    isLoading: boolean
    isError: boolean
    isFulfilled: boolean
    isSuccess: boolean
    data: Nullable<T>
    loadingDataId?: Nullable<string | number>
  }>({
    isLoading: false,
    isError: false,
    isSuccess: false,
    isFulfilled: false,
    data: null,
    loadingDataId: null,
  })

  const fetchData = async (params: {
    onFetchDataCallback: () => Nullable<Promise<T | void>> | void
    onErrorCatchCallback?: (e: unknown) => void
    loadingDataId?: string | number
  }) => {
    state.isLoading = true
    state.isError = false

    if (params.loadingDataId) {
      state.loadingDataId = params.loadingDataId
    }

    try {
      state.data = (await params.onFetchDataCallback()) as UnwrapRef<T>
      state.isLoading = false
      state.isSuccess = true
    } catch (e) {
      state.isError = true
      if (params.onErrorCatchCallback) {
        params.onErrorCatchCallback(e)
      }
    } finally {
      state.isLoading = false
      state.isFulfilled = true
      state.loadingDataId = null
    }
  }

  return {
    ...toRefs(state),
    fetchData,
  }
}
